import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class NgrokInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isNgrok = req.url.includes('ngrok-free.app') || req.url.includes('ngrok-free.dev');

    if (!isNgrok) {
      return next.handle(req);
    }

    const cloned = req.clone({
      setHeaders: {
        'ngrok-skip-browser-warning': 'true'
      }
    });

    return next.handle(cloned);
  }
}
